export default {
  exam: {
    1001: "Unlimited",
    1002: "Single",
    1003: "Multiple",
    1004: "Last",
    1005: "Next",
    1006: "Submit",
    1007: "Correct",
    1008: "Error",
    1009: "Unanswered",
    1010: "Click for details",
    1011: "Total score",
    1012: "",
    1013: "Accuracy",
    1014: "Answer",
    1015: "Right answer",
    1016: "Your answer",
    1017: "Great! Your answer is exactly right!",
    1018: "Unfortunately,your answer is wrong,keep trying!",
    1019: "Correct",
    1020: "Error",
    1021: "Full score",
    1022: "0",
    1023: "Close",
    1024: "Network busy. Answer again.",
    1025: "Answer again",
    1026: "Name",
    1027: "Tri - Party ID",
    1028: "Meeting ID",
    1029: "ID info",
  },
  lang: {
    k_870001: "option 1",
    k_870002: "option 2",
    k_870003: "option ",
    k_871001: "Title Name",
    k_874001: "Image Processing",
    k_874002: "Crop",
    k_874003: "Cancel Crop",
    k_874004: "Re-upload",
    k_874005: "Confirm",
    k_874006: "Cancel",
    k_876001: "Change",
    k_876002: "Recommended Size: 800*450px, <4M. Supported: JPG, GIF, PNG, BMP",
    k_876003: "Cover image must be in {0} format",
    k_876004: "Cover image size cannot exceed 4M",
    k_876005: "Uploading image...",
    k_877001: "Province/Municipality",
    k_877002: "City",
    k_877003: "District/County",
    k_877004: "Enter Detailed Address",
    k_878001: "Recommended Size: *px, <4M",
    k_878002: "Supported: JPG, GIF, PNG, BMP",
    k_878003: "Enter Content",
    k_879001: "Date",
    k_879002: "Time",
    k_879003: "Date & Time",
    k_880001: "SMS Verification",
    k_880002:
      "Enabled. Mobile number will be verified via domestic number segment check and verification code",
    k_881001: "Recommended Size: *px, <4M",
    k_881002: "Supported: JPG, GIF, PNG, BMP",
    k_881003: "Enter Content",
    k_882001: "Privacy Agreement",
    k_882002: "Show System Default Agreement",
    k_882003: "Preview Effect:",
    k_882004: "Submit & Agree",
    k_882005: "Privacy Policy",
    k_882006: "and",
    k_882007: "User Protection Agreement",
    k_882008: "Custom Agreement",
    k_882009: "Go to Settings",
    k_882010:
      '<a target="_blank" href="https://e.vhall.com/v3/privacyUPo">Privacy Statement</a> protects all information you provide',
    k_883001: "Privacy Agreement Settings",
    k_883002: "Privacy Agreement",
    k_883003: "Agreement Name",
    k_883004: "Redirect Link",
    k_883005: "Enter link starting with http:// or https://",
    k_883006: "Preview Effect",
    k_883007: "Confirm",
    k_883008: "Cancel",
    k_883009:
      "We protect your information in accordance with the Privacy Statement",
    k_883010: "Privacy Statement",
    k_883011: "Enter Agreement Name",
    k_883012:
      "Adding agreement exceeds preview word limit. Please shorten it first",
    k_883013: "Privacy Statement 2",
    k_883014: "{0} and {1}",
    k_883015: "{0} and",
    k_883016: "and {0}",
    k_883017: "Enter Valid URL",
    k_884001: "Province",
    k_884002: "City",
    k_884003: "District/County",
    k_884004: "Enter Detailed Address",
    k_885001: "Expand",
    k_885002: "Collapse",
    k_886001: "Date of Birth",
    k_887001: "Mobile Number",
    k_887002: "Yidun Placeholder",
    k_887003: "Dynamic Verification Code",
    k_887004: "Send Code",
    k_887005: "Enter Mobile Number",
    k_887006: "Enter Valid Mobile Number",
    k_888001: "Expand",
    k_888002: "Collapse",
    k_890001: "Title",
    k_890002: "Questionnaire Description",
    k_890003: "Extended Info",
    k_890004: "Text Question",
    k_890005: "Select Your Time",
    k_890006: "Region Selection Question",
    k_890007: "Single Choice",
    k_890008: "Option",
    k_890009: "Multiple Choice",
    k_890010: "Option 1",
    k_890011: "Option 2",
    k_890012: "Option 3",
    k_890013: "Option 4",
    k_890014: "Table",
    k_890015: "Column 1",
    k_890016: "Column 2",
    k_890017: "Row 1",
    k_890018: "Row 2",
    k_890019: "Pagination",
    k_890020: "Divider",
    k_890021: "Image & Text Note",
    k_890022: "Custom",
    k_890023: "Max 10 Options",
    k_890024: "Row",
    k_890025: "Column",
    k_891001: "Move",
    k_891002: "Copy",
    k_891003: "Delete",
    k_891004: "Add Option",
    k_891005: "Max 26 Options",
    k_891006:
      "Select question type, set correct answers and scores to create a question",
    k_891007: "Save",
    k_891008: "Tips",
    k_891009:
      "Save and share to Resource Management for use in other activities?",
    k_891010: "Share to Resource Management",
    k_891011: "Confirm",
    k_891012: "Cancel",
    k_891013: "Single Choice",
    k_891014: "Multiple Choice",
    k_891015: "Question {0} has no correct answer set",
    k_891016: "Question {0} has options without uploaded images",
    k_891017: "Saved Successfully!",
    k_891018: "Save Failed",
    k_892001: "Question Type",
    k_892002: "Text Single",
    k_892003: "Text Multiple",
    k_892004: "Image Single",
    k_892005: "Image Multiple",
    k_893001: "Global Settings",
    k_893002: "Quiz Participation Conditions",
    k_893003:
      "Enabled. Audience receives quiz pop-up automatically when cumulative viewing duration meets the requirement",
    k_893004:
      "When enabled, audience gets quiz pop-up after meeting cumulative viewing duration requirement",
    k_893005: "Cumulative Viewing",
    k_893006: " mins",
    k_893007: "",
    k_893008:
      "Tips: Quiz access is granted when viewing duration meets the requirement. Viewing duration definition: Total time a user stays in the live room. Paused time is not counted; duration resets when switching browsers; multi-device viewing durations are independent and not cumulative. Note: Duration resets if user identity is changed",
    k_893009: "Retry Opportunity",
    k_893010: "Enabled. Retry once if score is not full marks",
    k_893011: "When enabled, allow one retry if score is not full marks",
    k_893012: "Mandatory Submission",
    k_893013:
      "Enabled. Quiz page cannot be closed before successful submission",
    k_893014:
      "When enabled, quiz page cannot be closed before successful submission",
    k_893015: "Playback Submission",
    k_893016:
      "Enabled. Audience can take pushed quizzes when watching playback",
    k_893017: "When enabled, allow quiz participation during live playback",
    k_893018: "Quiz Duration",
    k_893019:
      "1. When enabled, audience must complete quiz within specified time. Countdown continues if audience leaves the page. It is recommended to remind audience not to leave for long",
    k_893020: "2. Quiz countdown starts when organizer pushes the quiz",
    k_893021: "Duration",
    k_893022: "sec",
    k_893023: "Complete quiz within time limit. Auto-submit when time's up",
    k_893024: "Auto-push Score Ranking",
    k_893025:
      "When quiz time limit is enabled, score ranking is pushed to audience automatically after countdown ends; manual push is required if disabled",
    k_893026: "Push ranking to audience automatically when quiz ends",
    k_893027: "Show Score & Answers",
    k_893028:
      "Enabled by default. Audience cannot view score or answers after quiz if disabled",
    k_893029: "Question Settings",
    k_893030: "Style",
    k_893031: "Image Top, Text Bottom",
    k_893032: "Image Left, Text Right",
    k_893033: "Layout",
    k_893034: "Single Col",
    k_893035: "Two Cols",
    k_893036: "Score",
    k_893037: "pts",
    k_893038: "Correct Answer (Single Choice)",
    k_893039: "Correct Answer (Multiple Choice)",
    k_893040: "Time limit unit modified. Please reset time limit",
    k_894001: "Question Count",
    k_894002: "Text Single Choice",
    k_894003: "Text Multiple Choice",
    k_894004: "Image Single Choice",
    k_894005: "Image Multiple Choice",
    k_894006: "Total Score",
    k_895001: "Previous Page",
    k_895002: "Next Page",
    k_896001: "Questionnaire",
    k_896002:
      "Modifying a questionnaire with collected data will re-statistics based on the updated version. To avoid affecting statistics,",
    k_896003:
      "it is recommended to copy a new questionnaire if you need to modify a pushed one",
    k_896004: "Create Questionnaire",
    k_896005: "Resource Library",
    k_896006: "Batch Delete",
    k_896007: "Enter Questionnaire Name",
    k_896008: "No questionnaires yet. Create one now!",
    k_896009: "Submit",
    k_896010: "Questionnaire Name",
    k_896011: "Update Time",
    k_896012: "Question Count",
    k_896013: "Preview",
    k_896014: "Copy",
    k_896015: "Edit",
    k_896016: "Delete",
    k_896017:
      "This questionnaire has been pushed. Modification will affect collected data. Confirm modification?",
    k_896018: "Tips",
    k_896019: "Confirm",
    k_896020: "Cancel",
    k_896021: "Modification Cancelled",
    k_896022: "Deleted questionnaires cannot be recovered. Confirm deletion?",
    k_896023: "Deleted Successfully",
    k_896024: "Deletion Failed",
    k_896025: "Deletion Cancelled",
    k_896026: "Select Options to Operate",
    k_897001: "Quiz Instructions",
    k_897002: "(Optional)",
    k_897003: "Enter Quiz Instructions",
    k_897004: "(Required)",
    k_897005: "Required Field",
    k_897006: "Save",
    k_897007: "Saved Successfully",
    k_898001:
      "When enabled, user information collection form is required to obtain accurate data; users only need to fill it once before taking multiple quizzes",
    k_898002: "User Info Collection Enabled",
    k_898003: "User Info Collection Disabled",
    k_899001: "Name",
    k_899002: "Gender",
    k_899003: "Male",
    k_899004: "Female",
    k_899005: "Date of Birth",
    k_899006: "Mobile",
    k_899007: "Email",
    k_899008: "Education Level",
    k_899009: "Industry",
    k_899010: "Region",
    k_899011: "Company",
    k_899012: "Department",
    k_899013: "Position",
    k_899014: "Employee ID",
    k_900001: "Privacy Agreement Settings",
    k_900002: "Privacy Agreement",
    k_900003: "Agreement Name",
    k_900004: "Redirect Link",
    k_900005: "Enter link starting with http:// or https://",
    k_900006: "Preview Effect",
    k_900007: "Confirm",
    k_900008: "Cancel",
    k_900009:
      "We protect your information in accordance with the Privacy Statement",
    k_900010: "Privacy Statement",
    k_900011: "Enter Agreement Name",
    k_900012:
      "Adding agreement exceeds preview word limit. Please shorten it first",
    k_900013: "Privacy Statement 2",
    k_900014: "{0} and {1}",
    k_900015: "{0} and",
    k_900016: "and {0}",
    k_900017: "Enter Valid URL",
    k_902001: "Single Choice",
    k_902002: "Multiple Choice",
    k_902003: "Download Image",
    k_902004: "Accuracy Rate:",
    k_902005: "{0} Respondents, {1} Options",
    k_902008: "Option",
    k_902009: "Percentage",
    k_902010: "Correct Answer",
    k_902011: "Number of Selections",
    k_902012: "Count",
    k_902013: "No Data Available",
  },
};
